/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { PermissionPaymentsResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class PermissionController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags permission-controller
   * @name GetPermissionsPayments
   * @request GET:/api/v1/permissions/payments
   * @deprecated
   */
  getPermissionsPayments = (params: RequestParams = {}) =>
    this.http.request<PermissionPaymentsResponse, any>({
      path: `/v1/permissions/payments`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPermissionsPaymentsPath = '/v1/permissions/payments'
  static getPermissionsPaymentsMethod = 'GET'
  /**
   * No description
   *
   * @tags permission-controller
   * @name GetPermissionsPaymentsForWallet
   * @request GET:/api/v1/permissions/payments/wallets/{walletId}
   */
  getPermissionsPaymentsForWallet = (walletId: string, params: RequestParams = {}) =>
    this.http.request<PermissionPaymentsResponse, any>({
      path: `/v1/permissions/payments/wallets/${walletId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPermissionsPaymentsForWalletPath = '/v1/permissions/payments/wallets/${walletId}'
  static getPermissionsPaymentsForWalletMethod = 'GET'
}
